<template>
  <div id="StockInventory">
    <div class="d-flex justify-content-between mx-4">
      <div>
          <q-btn v-if="user?.organization?.onlineOfflineType !== 2" class="offline-btn mt-3 mx-2"
            :class="[
              { 'pd-btn': currentTab == 'offline', 'inactive-btn': currentTab != 'offline' },
              { 'offline-btn': user?.organization?.onlineOfflineType !== 2, 'offline-btn-2': user?.organization?.onlineOfflineType === 2 }
            ]"  
            @click="changeCurrentTab('offline')" label="Offline Channel">
          </q-btn>
          <q-btn v-if="user?.organization?.onlineOfflineType !== 2" class="online-btn mt-3" :class="currentTab == 'online' ? 'pd-btn': 'inactive-btn'" 
            @click="changeCurrentTab('online')" label="Online Channel">
          </q-btn>
      </div>
      <div class="d-flex">
        <!-- <div v-if="currentTab === 'online' && user?.organization?.onlineOfflineType !== 2" 
                  @click="$router.push('/Partners/Stock/Products')" 
                  class="addButton-2 d-flex mt-1"
                  style="height: 40px;">
                  <div class=" mx-auto my-auto">Add Order</div>
              </div> -->
        <!-- <q-input v-model="searchData" class="searchBox" debounce="500" placeholder="Search" style="width: 350px">
          <template v-slot:prepend>
            <q-icon name="search" />
          </template>
</q-input> -->
      </div>
    </div>

    <q-separator v-if="user?.organization?.onlineOfflineType !== 2" class="mb-4 mt-3 mx-4"></q-separator>
    <RetailSalesVAPOffline v-show="currentTab === 'offline'" :searchData="searchData"></RetailSalesVAPOffline>
    <RetailSalesVAPOnline v-show="currentTab === 'online' && user?.organization?.onlineOfflineType !== 2"
      :searchData="searchData"></RetailSalesVAPOnline>
  </div>
</template>

<script>
import RetailSalesVAPOffline from './RetailSalesVAPOffline';
import RetailSalesVAPOnline from './RetailSalesVAPOnline';

export default {
  name: 'RetailSalesVAP',
  components: {
    RetailSalesVAPOffline,
    RetailSalesVAPOnline,
  },

  data() {
    return {
      searchData: '',
      currentTab: 'offline',
      user: JSON.parse(localStorage.getItem('user')),
    }
  },

  methods: {
    changeCurrentTab(value) {
      this.searchData = '';
      this.currentTab = value;
    }
  }
}
</script>

<style scoped>
.q-btn {
  text-transform: none !important;
  font-weight: 600;
  color: #105992
}

.offline-btn {
  border-radius: 8px 0px 0px 8px;
}

.offline-btn-2 {
    border-radius: 8px 8px 8px 8px;
}

.online-btn {
  border-radius: 0px 8px 8px 0px;
  margin-left: -9px;
}

.inactive-btn {
  background-color: #ECEFF1;
}
</style>